import {combineLatest} from 'rxjs';
import {filter, shareReplay, skipUntil, map} from 'rxjs/operators';
import {isLogin$} from '@/streams/auth';
import {browser$} from '@/streams/browser';
import {expiredRemainingFormatter$} from '@/modules/bonus/rewards-hub/stream';
import {kycInfo$} from '@/modules/account/overview/stream-kyc';

export const isUnverifed$ = combineLatest([isLogin$, kycInfo$]).pipe(
  skipUntil(browser$),
  filter(([isLogin]) => !!isLogin),
  map(([, kycInfo = {}]) => !kycInfo.kycStatus || ['Init', 'Unverified'].includes(kycInfo.kycStatus)),
  shareReplay(1)
);

// 倒计时文本：超多24小时时展示天和小时,剩余24小时大于1小时展示小时和分钟,剩余最后1小时展示分钟和秒
export const expiredRemainingText$ = expiredRemainingFormatter$.pipe(
  map(({d, h, m, s}) => {
    let text = '';
    // >= 24H
    if (d * 24 + h >= 24) {
      text = `${d.toString().padStart(2, '0')}d ${h.toString().padStart(2, '0')}h`;
    } else if (d * 24 + h >= 1 && d * 24 + h < 24) {
      // >= 1, < 24
      text = `${h.toString().padStart(2, '0')}h ${m.toString().padStart(2, '0')}m`;
    } else {
      text = `${m.toString().padStart(2, '0')}m ${s.toString().padStart(2, '0')}s`;
    }
    return text;
  })
);
